module.exports = __webpack_public_path__ + "static/emre-altan-6dd23dfd9a1c8593553b153a5b662f6b.jpg";